import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import './modal-header.css'
import {useDispatch, useSelector} from "react-redux";

import {onToggleAllLots} from "../../../../../redux/modals/modal-inline-mod-check/actionModal";

const ModalHeader = React.memo(() => {
    const dispatch = useDispatch();

    // Оптимизированные селекторы
    const {ak_au_phrase_allocated_lots, select_all} = useSelector((state) => 
        state.lots.phrases
    );

    const lotsData = useSelector((state) => 
        state.lots.lotsData
    );

    const changeLots = useSelector((state) => 
        state.modal.changeLots
    );

    // Мемоизируем вычисление
    const checkAllLots = useMemo(() => 
        changeLots.length === lotsData.length, 
        [changeLots.length, lotsData.length]
    );

    // Мемоизируем обработчик
    const handleToggleAll = useCallback(() => {
        dispatch(onToggleAllLots(!checkAllLots));
    }, [dispatch, checkAllLots]);

    return (
        <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title text-muted mb-0">
                {ak_au_phrase_allocated_lots}: {changeLots.length}
            </h5>

            <div className="form-check">
                <input 
                    checked={checkAllLots}
                    onChange={handleToggleAll}
                    className="form-check-input"
                    id="select_all"
                    type="checkbox"
                />
                <label className="form-check-label text-muted mt-1" htmlFor="select_all">
                    {select_all}
                </label>
            </div>
        </div>
    );
});

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;